import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import { setSearchTerm, clearSearchTerm, getSuggestions, clearSearch } from '../../redux/actions/result.action';
import { loadContentForPage, pushAndStop, backAndStop, setData, alreadyPlayed } from '../../redux/actions/text.action';
import './InputText.scss';

//icon
import searchIcon from '../../assets/search.png';

//text
import assistantText from '../../assets/text/text.json';
import PrimaryButtonCardFitContent from '../../components/PrimaryButtonCardFitContent/PrimaryButtonCardFitContent';

/**
 * Home page component
 */
class InputText extends Component<{ navigateTo: any, setText: any, term: any, back: any, setCurrentpage: any, blockVoice: any }, { searchTerm: string }> {
    constructor(props: any) {
        super(props);
        this.state = {
            searchTerm: ""
        }
    }

    componentDidMount() {
        if (this.props.term && this.props.term.length > 0) {
            this.setState({ searchTerm: this.props.term })
        }
        this.props.setCurrentpage();
    }

    renderBody() {
        return (
            <div className="inputext-container">
                <input type="text" className="input-text-input" value={this.state.searchTerm} onChange={(event) => {
                    this.props.blockVoice();
                    this.setState({ searchTerm: event.target.value })
                }} />

                <PrimaryButtonCardFitContent text="Fertig" action={() => {
                    if(this.state.searchTerm !== "") {
                        this.props.setText(this.state.searchTerm);
                        this.props.navigateTo('/subresult');
                    }
                }} icon={searchIcon} />
            </div>
        )
    }

    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="inputext">
                <PageTemplate assistantLine1={assistantText.textMethode.Assistant.line1} body={this.renderBody()} customBack={() => {
                    this.props.back();
                }} text={["Fertig"]} />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        term: state.result.searchTerm
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        navigateTo(path: string) {
            dispatch(pushAndStop(path));
            dispatch(alreadyPlayed(false));
        },
        setText(term: string) {
            dispatch(clearSearchTerm());
            dispatch(setSearchTerm(term));
            dispatch(getSuggestions(term));
            dispatch(setData(null));
        },
        back() {
            dispatch(clearSearch());
            dispatch(backAndStop());
            dispatch(alreadyPlayed(false));
        },
        setCurrentpage() {
            dispatch(loadContentForPage("textMethode"));

        },
        blockVoice() {
            dispatch(alreadyPlayed(true));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InputText);